import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import WayPoints from './WayPoints';
import ToPickup from './ToPickup';
import useDirections from './useDirections.hook';

function WayPointsContainer(props) {
  const {
    fromWaypoint,
    toWaypoint,
    directionsFrom,
    directionsTo,
    vehicleLocation,
    currentSegment,
    location,
    inProgress,
    atDropoffTime,
    pickupTime,
    isNonTransport,
  } = props;
  const directions = useDirections(directionsFrom, directionsTo, departureTime);
  const getDropoffTime = () => {
    if (!pickupTime) {
      return null;
    }

    return inProgress
      ? atDropoffTime
      : moment(pickupTime)
          .add(directions ? directions.duration : 0, 's')
          .toISOString();
  };

  return (
    <>
      {currentSegment.toPickup && <ToPickup from={vehicleLocation} to={fromWaypoint} />}
      <WayPoints
        {...props}
        directions={directions}
        showRoute={directions && !currentSegment.atDropoff && !isNonTransport}
        dropoffTime={getDropoffTime()}
        showVehicle={inProgress && !currentSegment.toPickup && vehicleLocation.lat && !isNonTransport}
        fromWaypoint={fromWaypoint || location}
        toWaypoint={isNonTransport ? false : toWaypoint}
      />
    </>
  );
}

WayPointsContainer.propTypes = {
  pickupTime: PropTypes.string,
};

WayPointsContainer.defaultProps = {
  pickupTime: null,
};

const directionsFrom = ({ fromWaypoint, vehicleLocation }, currentSegment, dropOffSegment, dropoffComplete) => {
  if (dropoffComplete) {
    return dropOffSegment?.start_location || fromWaypoint;
  }
  return currentSegment.order && !currentSegment.toPickup && vehicleLocation.lat ? vehicleLocation : fromWaypoint;
};

const directionsTo = ({ toWaypoint }, dropOffSegment, dropoffComplete) => {
  return dropoffComplete && dropOffSegment ? dropOffSegment.end_location : toWaypoint;
};

const departureTime = (currentSegment, dropOffSegment, segments, dropoffComplete) => {
  if (!currentSegment.state && !dropoffComplete) {
    return null;
  }
  const current = dropoffComplete ? dropOffSegment : segments?.find(s => s.state === currentSegment.state);
  const startAt = moment(current.start_at);
  if (startAt.isBefore(moment())) {
    return null;
  }
  return current.start_at;
};

function mapStateToProps({
  map,
  schedule: { scheduleState, complete, currentSegment, atPickupTime, atDropoffTime, segments },
  eta,
  requests: { request, isNonTransport },
}) {
  const dropOffSegment = segments?.find(s => s.state === 'to_drop_off');
  const dropoffComplete = complete;
  return {
    ...map,
    scheduleState,
    departureTime: departureTime(currentSegment, dropOffSegment, segments, dropoffComplete),
    directionsFrom: directionsFrom({ ...map }, currentSegment, dropOffSegment, dropoffComplete),
    directionsTo: directionsTo({ ...map }, dropOffSegment, dropoffComplete),
    complete,
    pickupComplete: complete || currentSegment.pickupComplete,
    dropoffComplete,
    inProgress: request.inProgress,
    pickupTime: request.inProgress ? atPickupTime : eta.pickupTime,
    atDropoffTime,
    segments,
    currentSegment,
    dropOffSegment,
    effectGuard: [],
    isNonTransport,
  };
}

export default connect(mapStateToProps, {})(WayPointsContainer);
